
import {Moment} from "moment";

export interface ITemperatureCardData {
  telegramDay: Moment;
  waterTemperature: number;
  airTemperature: number;
}

export default class OperationalInputTemperatureCardController {
  /**
   * Displayed water level data.
   */
  temperatureData: ITemperatureCardData;
}



/** WEBPACK FOOTER **
 ** ./app/operational/input/kn15-telegram/temperature-card.controller.ts
 **/